// extracted by mini-css-extract-plugin
export default {"contentHeader":"ResumeClaimSubmission_contentHeader__u-3lL","appleLogo":"ResumeClaimSubmission_appleLogo__VgRLk","resumeClaimSB":"ResumeClaimSubmission_resumeClaimSB__7dH0N"};